import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Gift } from 'lucide-react';
import { apiGet } from '@/lib/api';

/**
 * "Earn Free Month" pill in the header — modeled on Emergent's gift-icon CTA.
 * Pulses gently to draw the eye; on click takes the user to /refer.
 */
export default function ReferEarnPill() {
  const navigate = useNavigate();
  const [balance, setBalance] = useState(null);
  const [enabled, setEnabled] = useState(true);

  useEffect(() => {
    let ignore = false;
    apiGet('/referrals/me')
      .then(d => {
        if (ignore) return;
        setBalance(d?.balance ?? null);
        setEnabled(d?.enabled !== false);
      })
      .catch(() => {});
    return () => { ignore = true; };
  }, []);

  if (!enabled) return null;

  const pts = balance?.balance ?? 0;
  const showCount = pts > 0;

  return (
    <button
      data-testid="refer-earn-pill"
      onClick={() => navigate('/refer')}
      title="Refer & Earn — free month of Growth"
      className="relative flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-gradient-to-r from-emerald-50 via-teal-50 to-emerald-50 ring-1 ring-emerald-300 text-emerald-700 hover:shadow-md hover:scale-[1.03] transition-all mr-1 group"
    >
      <span className="absolute -inset-0.5 rounded-full bg-gradient-to-r from-emerald-400 to-teal-400 opacity-30 blur group-hover:opacity-50 animate-pulse" aria-hidden="true" />
      <Gift className="w-3.5 h-3.5 relative flex-shrink-0" />
      {/* Iter 60i — label only on 2xl+ so 1440–1920px screens stay one row. */}
      <span className="hidden 2xl:inline font-heading text-xs font-semibold relative tracking-tight whitespace-nowrap">
        {showCount ? `${pts} pts · Refer & Earn` : 'Earn Free Month'}
      </span>
    </button>
  );
}
